import {
  Context as PosContext,
  Environment,
  Receipt,
  SDKAction,
  order as orderApi,
  sdk as sdkApi, DiscountType, DiscountScope,
} from "@squareup/sq-addons-web-sdk";
import { useEffect } from "react";

// import { orderLineDiscountsToDiscounts } from "converters/orderDiscountsConverter";
// import { retrieveLoyaltyAccount } from 'store/api/customer/retrieveLoyaltyAccount';
// import { accumulateLoyaltyPoints } from 'store/api/discounts/accumulateLoyaltyPoints';
// import { retrieveLoyaltyProgram } from "store/api/discounts/retrieveLoyaltyProgram";
// import { redeemReward } from "store/api/discounts/redeemReward";
import { CONTEXT, CUSTOMER, ORDER } from "local-host-data";
import { buildDigitalReceipt, buildPrintedReceipt } from "utils/receipt";
import { TransactionInput, squareToLavaLineItems, squareToLavaAppliedDiscounts } from '../lava/api';

const PostPaymentSlot = () => {
  useEffect(() => {
    (async function () {
      let posContext: PosContext | undefined;

      async function getReceipts(): Promise<Receipt> {
        while (!posContext) {
          // Wait until posContext has been set from the SDK::INITIALIZE.
          await new Promise((resolve) => setTimeout(resolve, 500));
        }

        const customer = await orderApi.getCustomer();
        // Jude TODO: remove this hard-coding once done testing
        // customer.referenceId = '595a8827-cc7d-4e5c-bb98-465a3a6a8e54';
        const order = await orderApi.retrieve();
        // const locationId = posContext.configurations.locationId as string;

        const lavaDomain = posContext.configurations.environmentUrl;

        // TODO Chris: getCustomerId
        let referenceId = "";
        if (customer.referenceId) {
          referenceId = customer.referenceId;
        }

        const transactionInput: TransactionInput = {
          authorize_only: false,
          items: [],
          location: order.locationId,
          reference_id: order.id || '',
          membership_id: referenceId,
          discounts_applied: []
        };

        transactionInput.items = squareToLavaLineItems(order)
        transactionInput.discounts_applied = squareToLavaAppliedDiscounts(order);

        const response = await fetch(
          `${lavaDomain}/v1/transactions`,
          {
            method: "POST",
            body: JSON.stringify(transactionInput),
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 404) {
          throw new Error("Not found");
        }

        if (Math.floor(response.status/100) !== 2) {
          throw new Error("Error calling the Lava Discounts API");
        }

        // let result = await response.json();

        // Redeem any rewards applied to the order
        try {
          // const addonDiscounts = (order.discounts ?? []).filter(
          //   (discount: OrderLineItemDiscount) => !!discount.metadata?.rewardId
          // );

          // for (const discount of orderLineDiscountsToDiscounts(
          //   addonDiscounts
          // )) {
          //   await redeemReward(
          //     posContext,
          //     discount.metadata.rewardId,
          //     locationId
          //   );
          // }

          // Jude TODO: Test with order created in the orders API
          // Accumulate loyalty points accrued on the non-discounted order balance
          // const pointEarnedQuantity = await accumulateLoyaltyPoints(
          //   posContext,
          //   customer.referenceId,
          //   locationId,
          //   order.id as string
          // );
          // const pointEarnedQuantity = 1;

          // Construct the receipt
          // const program = await retrieveLoyaltyProgram(posContext);

          // const singularPointName = "point";
          // const multiplePointName = "points";

          // const trackingUrl = "https://lava.ai";

          const receipt: Receipt = {};
          const receiptTexts = [buildDigitalReceipt, buildPrintedReceipt].map(
            (buildReceipt) => {
              return buildReceipt();
            }
          );
          receipt.digital = receiptTexts[0] ?? undefined;
          receipt.printed = receiptTexts[1] ?? undefined;

          return receipt;
        } catch {
          throw new Error(
            `Error generating receipt.\n\n Customer was ${JSON.stringify(
              customer
            )}.\n\n\n Order was ${JSON.stringify(order)}.`
          );
        }
      }

      const sdkEnv = process.env.SQ_ADDONS_SDK_ENVIRONMENT as string;

      posContext = await sdkApi.initialize(
        {
          [SDKAction.DEVICE_GET_RECEIPTS]: async () => {
            return await getReceipts();
          },
        },
        {
          environment:
            sdkEnv === "LOCALHOST" ? Environment.LOCAL_HOST : Environment.POS,
          localHostData: {
            context: CONTEXT,
            order: ORDER,
            customer: CUSTOMER,
          },
        }
      );
    })();
  }, []);

  return <></>;
};

export default PostPaymentSlot;
